import React, { ReactElement } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import { BreederAdminsProvider, BreedersProvider } from 'dogpark/context';
import { Breeders, BreederAdminUsers } from 'dogpark/pages';
import { DogParkRoutes } from 'dogpark/utilities/const';
import { useUserCapabilities } from 'shared/hooks';
import { UserCapabilities } from 'utilities/const';

export const DogPark = (): ReactElement | null => {
  const { capabilities, loadingCapabilities } = useUserCapabilities();

  if (loadingCapabilities) return null;

  return capabilities.includes(UserCapabilities.UseDogParkApp) ? (
    <BreedersProvider>
      <BreederAdminsProvider>
        <Switch>
          <Route
            path={`${DogParkRoutes.Breeders}/:searchBy?/:searchValue?`}
            component={Breeders}
          />
          <Route
            path={`${DogParkRoutes.BreederAdminUsers}/:searchBy?/:searchValue?`}
            component={BreederAdminUsers}
          />
        </Switch>
      </BreederAdminsProvider>
    </BreedersProvider>
  ) : (
    <Switch>
      <Redirect to="/dashboard" />
    </Switch>
  );
};
